module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/wellcome/wellcome.component.css
// module id = ./src/app/components/wellcome/wellcome.component.css
// module chunks = main